import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/riders', { params })
  },
  store (formData) {
    return apiClient.post('/riders', formData)
  },
  show (id, params) {
    return apiClient.get(`/riders/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/riders/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/riders/${id}`)
  }
}
